var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

exports = module.exports = typeof _Object$keys === 'function' ? _Object$keys : shim;
exports.shim = shim;

function shim(obj) {
  var keys = [];

  for (var key in obj) {
    keys.push(key);
  }

  return keys;
}